
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-seekers/submission-success",
      function () {
        return require("private-next-pages/job-seekers/submission-success/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-seekers/submission-success"])
      });
    }
  